import { render, staticRenderFns } from "./document-history-new.vue?vue&type=template&id=094ccbfa&scoped=true&"
import script from "./document-history-new.vue?vue&type=script&lang=js&"
export * from "./document-history-new.vue?vue&type=script&lang=js&"
import style0 from "./document-history-new.vue?vue&type=style&index=0&id=094ccbfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094ccbfa",
  null
  
)

component.options.__file = "document-history-new.vue"
export default component.exports